import { Component,  OnInit,  ViewChild, ElementRef,Renderer2,HostListener, ViewChildren, QueryList   } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PageService } from '../../../services/shared/page.service';
import { CommonService, SpinnerService, } from 'src/app/services/service.index';
import { Page } from 'src/app/models/page.model';
import { environment } from 'src/environments/environment.prod';
import { MessagesService } from 'src/app/services/common/messages.service';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { Link } from 'src/app/models/menu';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { ResourceParameter } from 'src/app/services/microapplications/_models/resource-parameter.model';
import { ChangeDetectorRef } from '@angular/core';
import { DxPopoverComponent } from 'devextreme-angular';
import { positionConfig } from 'devextreme/animation/position';
import { AnyARecord } from 'dns';
declare function encryptString(plainText: string): any;

@Component({
  selector: 'app-page-tab-panel',
  templateUrl: './page-tab-panel.component.html',
  styleUrls: ['./page-tab-panel.component.scss']
})
export class PageTabPanelComponent implements OnInit {
  // @ViewChild('myIframe') myIframe!: ElementRef;
  // @ViewChild('myIframe') myIframe: ElementRef<HTMLIFrameElement>;
  // @ViewChild('myIframe') myIframe!: ElementRef<HTMLIFrameElement>;
@ViewChildren('myIframe') iframes!: QueryList<ElementRef<HTMLIFrameElement>>;
  @ViewChild('popover', { static: false }) popover!: DxPopoverComponent;
  @ViewChild('optionsButton', { static: false }) optionsButton!: ElementRef;
  
  public listHistorial = JSON.parse(
    sessionStorage.getItem('listHisotrial') || '[]'
  );
  urlSafe: SafeResourceUrl | undefined;
  // url: string = 'http://localhost:4200';
  // url: string = environment.urlSiteDynamicsForms;
  versionPortal: any = environment.appVersion;
  urlObserver$: Observable<SafeResourceUrl>;
  pages: Page[] = [];
  pages$:Page[];

  selectedIndex: number = 0;
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>('');
  link: any;
  rightcontent: any = null;
  rightMenuOpened: boolean = false;
  listProcess: any[] = [];
  Linkdata: Link[]= [];
  html: SafeResourceUrl;
  pagesSe: Page[] = [];
  tokeshistori: string;
  datamainform: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  @ViewChild("tabs") tabs: any;
  @ViewChild("iframe") iframe: any;

  usu_code: any;

  Status: any[];

  public sessionData = JSON.parse(
    sessionStorage.getItem('sessionData') || '{}'
  );
  code: any;
  codigoForm: string;
  selectedIndexInci: 0;
  dimensions: string;
  iframeWidth = window.innerWidth;
  iframeHeight = window.innerHeight;
  isPopupVisible: boolean;
  iframeHeightt: string;
  iframeHeightVH: string;
  my: { x: 'left', y: 'top' }
at: { x: 'left', y: 'bottom' }
  popoverPosition: {
    my: { readonly x: "center"; readonly y: "top"; }; at: { readonly x: "center"; readonly y: "bottom"; } | { readonly x: "left"; readonly y: "bottom"; }; // pantallas normales
    of: any; collision: string;
  };

   private subs = new Subscription();

  constructor(private _pageService: PageService,
    private _commonServices: CommonService,
    private _router: Router,
    private servicemicroapp: MicroapplicationService,
    private activatedRoute: ActivatedRoute,
    private _messagesService: MessagesService,
    private auth: AuthService,
    private sanitizer: DomSanitizer,
    private _spinnerService: SpinnerService,
    private _commonService: CommonService,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef
    

 ) {

  this.pages$=this.pages

  }



  ngOnInit(): void {

     this.subs.add(
      this.auth.tokenBroadcast$.subscribe(token => {
        if (token) {
          this.broadcastTokenToIframes(token);
        }
      })
    );
    
    const storedPages = sessionStorage.getItem('Pages');
    this.setPopoverPosition();
    this.updateIframeHeight();
    window.addEventListener('resize', this.updateIframeHeight.bind(this));
  
    if (storedPages) {
      try {
        this.pages = JSON.parse(storedPages) || [];
  
        if (this.pages.length && this.pages[0]) {
          this.pages[0].id = 0;
        }
      } catch (error) {
        this._messagesService.warning('Página ya está abierta. No se duplicará:', error);
        this.pages = [];
      }
    }
  
    this.usu_code = this.sessionData.accountCode;
  
    this._pageService.pageEmitter.subscribe((data: any) => {
      if (!data?.name) return;
  
      // Validar si ya existe por ID o por URL
      const count = this.pages.filter(
        p => p.idForm === data.idForm || p.url === data.url
      ).length;
      
      if (count >= 2) {
        // this._messagesService.warning('Página ya está abierta en dos pestañas. No se duplicará:');
        return; // Ya existe 2 veces, no agregar más
      }
  
      const page: Page = {
        ...data,
        id: this.pages.length === 1 ? 1 : this.pages.length,
        url: data.url
      };
  
      this.selectedIndex = this.pages.length;
       this.pages.push(page);
  
      this.cdRef.detectChanges();
      // sessionStorage.setItem('Pages', JSON.stringify(this.pages));
  
      // this.calcProcess(page);
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.updateIframeHeight.bind(this));
    this.subs.unsubscribe();
  }
  
  updateIframeHeight() {
    const windowHeight = window.innerHeight; // altura real disponible en px
    const screenHeight = window.screen.height; // altura física de pantalla
  
    // Detectar zoom aproximado
    const zoomLevel = window.innerWidth / window.screen.width;
  
    // Base: usar % de la ventana visible (ejemplo: 80%)
    let heightPx = windowHeight * 0.7;
    let heighthv=0
    // Ajustar con base en zoom
    if (zoomLevel > 1) {
      // zoom in → reducimos un poco
      heightPx -= 50; // quita 50px (puedes ajustar a tu gusto)
      heighthv=10
    } else if (zoomLevel < 1) {
      // zoom out → añadimos un poco
      heightPx += 50;
    }
    let adjustment = 0;
    // Convertimos a vh relativo al alto actual de la ventana
    const heightVH = (heightPx / windowHeight) * 100;
  
  // Validación por tamaño de pantalla
  const screenWidth = window.innerWidth;
  if (screenWidth < 768) {
    // móviles
    adjustment -= 5;
  } else if (screenWidth >= 768 && screenWidth < 1200) {
    // tablets
    adjustment -= 10;
  } 
 else if (screenWidth >= 1900 ) {
  // tablets
  adjustment += 3;
} 
  else {
    // desktops
    adjustment += 12;
  }

  // Validación por nivel de zoom
  switch (true) {
    case zoomLevel > 1:
      adjustment += 10;
      break;

    case zoomLevel < 1 && zoomLevel > 0.8:
      adjustment -= 10;
      break;

    case zoomLevel <= 0.8:
      adjustment -= 10;
      break;

    case zoomLevel === 1:
      adjustment -= 4;
      break;
  }

  // Aplicar ajuste
  this.iframeHeightVH = `${heightVH + adjustment}vh`;


    // this.iframeHeightVH = `${(heightVH-11)}vh`;
  }
  
  getIframeScrollWrapperStyle() {
    return {
      overflowX: 'auto',
      overflowY: 'auto',
      height: this.iframeHeightVH,
      width: '100%',
    };
  }
  getmainformlist(code:string) {


    this.servicemicroapp.GetMainFrom(this.usu_code, code).subscribe(resp => {
      if (resp.isSuccessful) {
        this.Linkdata = [];
        this.datamainform.next(resp.result);
        if (resp.result.length > 0) {
          for (let i = 0; i < resp.result.length; i++) {
          this.Linkdata.push({
            __KEY__:resp.result[i]. __KEY__,
            Code:resp.result[i].code,
            Description:resp.result[i].description,
            MicroApplication_Id:resp.result[i].MicroApplication_Id
            ,
             
          });
        }
      }
      }
    });
  }


  onValueMainform(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const microAppId = selectElement.value;
  
    if (!microAppId) return;
  
    this.openMicroApp(microAppId);
    this.isPopupVisible = false;
  
    //  resetear para que siempre pueda re-seleccionar
    setTimeout(() => {
      selectElement.value = "";
    }, 100);
  }

  openMicroApp(id: any): void {
    this.servicemicroapp.GetMicroApplicationsById(id).subscribe({
      next: (microApp) => {
        if (!microApp?.isSuccessful) {
          this._messagesService.error('No se pudo cargar la micro aplicación');
          return;
        }
  
        const result = microApp.result;
        this.tokeshistori = this.auth.getAuthFromLocalStorage().accessToken;
        this.codigoForm = result.code;
        this.Linkdata = this.mapLinks(result.link);
        
        const url = this.buildUrlWithParameters(result.url, result.parameters);
  
        const page: Page = {
          codProg: "0",
          name: result.name.esCO,
          idForm: id,
          id: 0,
          url,
          cambiarUrl: true,
          typeForm: 'maestro',
          lisnk: this.Linkdata
        };
  
        this.pagesSe.push(page);
  
        this._commonService.setItemsessionStorage('Pages', this.pagesSe);
        this.removeClass('open-item');
        this._spinnerService.close();
  
        this._router.navigate(['/pageTabPanel']);
        this.addHistorial(page);
        this._pageService.generarPage(page);
      },
      error: () => {
        this._messagesService.error('Error conectando con servicio de microaplicaciones');
      }
    });
  }
  
  private mapLinks(links: any[]): any[] {
    if (!Array.isArray(links)) return [];
    return links.map(l => ({
      __KEY__: l.__KEY__,
      Code: l.code,
      Description: l.description,
      MicroApplication_Id: l.microApplication_Id
    }));
  }
  
  private buildUrlWithParameters(baseUrl: string, parameters: any[] = []): string {
    const query = parameters
      ?.map((p, i) => `${p.code}=${this.GetGlobalVariables(p)}`)
      .join('&');
    return `${baseUrl}?${query}`;
  }
  

  
  getIframeHeightVH(): number {
    const height = window.innerHeight;
  
    if (window.innerWidth >= 1920) return (height - 100) / (height / 100); // deja margen de 100px
    if (window.innerWidth >= 1386) return (height - 80) / (height / 100);  // margen dinámico
    return (height - 60) / (height / 100);
  }
  getIframeWrapperStyle() {
    const width = window.innerWidth;
    let heightPercent: number;
  
    if (width >= 1920) {
      heightPercent = 120;
    } else if (width >= 1600) {
      heightPercent = 107;
    } else if (width >= 1366) {
      heightPercent = 122;
    } else {
      heightPercent = 100;
    }
  
    return {
      transformOrigin: 'top left',
      width: '100%',
      height: `${heightPercent}%`
    };
  }
  
  getScale(): number {
    const width = window.innerWidth;
    if (width >= 1920) return 0.85;
    if (width >= 1366) return 0.9;
    return 1;
  }

  
  loadDimensions() {
    this.dimensions = `width: 100%; height:${this.gridHeight()}px;border:none`;
  }
  
  gridHeight = () => {
    return Math.round(window.innerHeight / 1);
  }

  addHistorial(node: any) {
   
    let index = this.listHistorial.findIndex(
      (e: any) => e.idForm == node.idForm
      
    );
    if (index != -1) {
      this.listHistorial.splice(index, 1);
      this.listHistorial.push(node);
    } else {
      this.listHistorial.push(node);
    }

    if (this.listHistorial.length > 3) {
      this.listHistorial = this.listHistorial.slice(
        this.listHistorial.length - 3
      );
    }
    sessionStorage.setItem('listHisotrial', JSON.stringify(this.listHistorial));
  }

  GetGlobalVariables(param: ResourceParameter) {
    if (param.type == 0) {
      return param.value;
    } else {
      switch (param.code) {
        case "token":
          return this.auth.getAuthFromLocalStorage().accessToken;
        case "companyCode":
          return this.auth.currentUserValue.selectedCompany.code;
      }
    } return null
  }
  ngAfterViewInit() {
    window.addEventListener('message', this.receiveMessage.bind(this), false);
    this.setPopoverPosition();
    // escuchamos cambios de tamaño de pantalla
    window.addEventListener('resize', () => this.setPopoverPosition());
  }

  receiveMessage(event: MessageEvent) {
    if (event.data.type === 'FormasVersion') {
      let verConFormas = this.versionPortal.split('.');
      verConFormas[1] = event.data.data.toString();
      this.versionPortal = verConFormas.join('.');
      // this._sideBarService.enviarVersionFormas(this.versionPortal);
      window.removeEventListener('message', this.receiveMessage);
    }
  }

  onRightClick($e: any, content: any) {
    this.rightcontent = content;
    let ctxMenu: any = document.getElementById("content-menu");
    ctxMenu.style.display = "block";
    ctxMenu.style.left = ($e.pageX - 50) + "px";
    ctxMenu.style.top = ($e.pageY) + "px";
    this.rightMenuOpened = true;
    return false;
  }
  closeMenu() {

    let ctxMenu: any = document.getElementById("content-menu");
    ctxMenu.style.display = "none";
    this.rightMenuOpened = true;
    return false;
  }
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    // Si el clic ocurre fuera del div, se cierra el menú
    if (this.rightMenuOpened == true) {
      this.closeMenu();
    }
  }
  CloseRightMenu() {
    try {
      let ctxMenu: any = document.getElementById("content-menu");
      ctxMenu.style.display = "";
      ctxMenu.style.left = "";
      ctxMenu.style.top = "";
      this.rightMenuOpened = false;
    } catch (err) { }
  }


  closeButtonHandler(itemData: any) {

      this.closePage(itemData);


  }



  closePage(itemData: any) {
    const index = this.pages.indexOf(itemData);
    this.pages.splice(index, 1);
    if (index >= this.pages.length && index > 0) this.selectedIndex = index - 1;
    if (this.pages.length === 0) { this._router.navigate(['/dashboard']); this.removeClass("open-item"); }
    this.CloseRightMenu();
    sessionStorage.setItem('Pages', JSON.stringify(this.pages));
    window.removeEventListener("message", (event) => {
    })
  };


  closeTheOthersHandler(itemData: any) {
    const index = this.pages.indexOf(itemData);
    this.pages = this.pages.filter((v: any, i: any) => i == index);

    if (index >= this.pages.length && index > 0) this.selectedIndex = index - 1;
    if (this.pages.length === 0) { this._router.navigate(['/dashboard']); }
    this.CloseRightMenu();
    sessionStorage.setItem('Pages', JSON.stringify(this.pages));
  }
  closeAllHandler(): void {
    if (!this.pages || this.pages.length === 0) {
      console.warn("No hay páginas abiertas para cerrar.");
      return;
    }
    this.pages = [];
    this.removeClass("open-item");
    localStorage.removeItem('Pages');
    this.CloseRightMenu();
    this.pages.length = 0;
    this.savePagesToSession();
    // Solo navega si no está ya en dashboard
    if (this._router.url !== '/dashboard') {
      this._router.navigate(['/dashboard']);
    }
  }
  
  private savePagesToSession(): void {
    sessionStorage.setItem('Pages', JSON.stringify(this.pages));
  }
  

  showCloseButton() {
    return this.pages.length > 1;
  }

  async adicionarPage(data: any) {
    let page: Page = data;
    page.id = !this.pages.length ? 0 : this.pages.length + 1;
    page.url= data.url;
    this.selectedIndex = this.pages.length;
    this.pages.push(page);
    sessionStorage.setItem('Pages', JSON.stringify(this.pages))
    this.link = undefined;
  
  }
  onReorder(e: any) {
    if(e?.fromIndex== e?.toIndex)return;
    this._messagesService.confirm("Reordenar pestañas", "Si reordena las pestañas se recargan los programas abiertos", "warning")
    .then((result: any) => {
      if (result.isConfirmed) {    
        const newIndex = e.toIndex;
        const movedItem = this.pages.splice(e.fromIndex, 1)[0];
        this.pages.splice(newIndex, 0, movedItem);
      } else if (result.isDenied) {
        e.cancel;
      }
    });
  }

  selectionChanged = (e: any) => {   
    
    this.addClass(e.addedItems[0].codProg, "open-item");
 
    this.selectedIndexInci = e.component.option('selectedIndex');


  }

  addClass = (name: string, classs: string) => {
    try {
      this.removeClass(classs);
      let nodes = document.querySelectorAll(`.sp-menu__link:not(.sp-menu__toggle)[name=${name}]`);
      nodes.forEach(node => {
        node.classList.add(classs)
      })
    } catch (error) { }
  }

  removeClass = (classs: string) => {
    let nodes = document.querySelectorAll(`.${classs}`);
    nodes.forEach(node => {
      node.classList.remove(classs)
    })
  }
  
  
  reloadIframe(data:any) {
    
    this.tokeshistori=this.auth.getAuthFromLocalStorage().accessToken;
    if(data.idForm==null){
      const newToken = this.tokeshistori;
     data.url = data.url.replace(/(token=)[^&]+/, `$1${newToken}`);

    // const activeIndex = this.selectedIndexInci; 
    const activeIndex = this.selectedIndexInci != null && this.selectedIndexInci >= 0
    ? this.selectedIndexInci
    : 0;
 // Obtener el iframe activo
 const activeIframe = this.iframes.toArray()[activeIndex];;
  
 // Actualizar la URL
 this.renderer.setAttribute(activeIframe.nativeElement, 'src', '');
 setTimeout(() => {
   this.renderer.setAttribute(activeIframe.nativeElement, 'src', data.url);
 }, 100);

     this.CloseRightMenu();
    }
    else{

      this.servicemicroapp.GetMicroApplicationsById(data.idForm).subscribe((microApp) => {
        if (microApp.isSuccessful) {
          let url = `${microApp.result.url}?`;
        
          this.tokeshistori=this.auth.getAuthFromLocalStorage().accessToken;
         this.codigoForm=microApp.result.code;
          if (microApp.result.parameters != null) {
            let i = 0;
            for (const parameter of microApp.result.parameters) {
         
              url += `${i === 0 ? '' : '&'}${parameter.code}=${this.GetGlobalVariables(parameter)}`;
              i += 1;
            }
            data.url= url;

            // const activeIndex = this.selectedIndexInci; 
            const activeIndex = this.selectedIndexInci != null && this.selectedIndexInci >= 0
  ? this.selectedIndexInci
  : 0;
            // Obtener el iframe activo
            const activeIframe = this.iframes.toArray()[activeIndex];;
             
            // Actualizar la URL
            this.renderer.setAttribute(activeIframe.nativeElement, 'src', '');
            setTimeout(() => {
              this.renderer.setAttribute(activeIframe.nativeElement, 'src', url);
            }, 100);

            this.CloseRightMenu();
  
          }
        }
      }, err => {
  
        this._messagesService.error('Error conectando con servicio de microaplicaciones');
        this.CloseRightMenu();
      });
    }

 
  }

  togglePopup() {
    this.isPopupVisible = !this.isPopupVisible;
    this.repositionPopover();
  }

  repositionPopover() {
    setTimeout(() => {
      if (this.popover?.instance) {
        this.popover.instance.repaint();
      }
    }, 0);
  }

  // Cuando termina el drag: reposicionar
  onDragEnded() {
    this.repositionPopover();
  }

  // Cuando cambia el tamaño de la ventana: reposicionar
  @HostListener('window:resize')
  onResize() {
    this.repositionPopover();
  }

   setPopoverPosition(): void {
    const isLargeScreen = window.innerWidth > 1900;

        if (window.innerWidth > 1900) {
          this.popoverPosition = {
            my: { x: 'center', y: 'top' } as const,
            at: isLargeScreen
              ? { x: 'center', y: 'bottom' } as const // pantallas grandes
              : { x: 'left', y: 'bottom' } as const, // pantallas normales
            of: this.optionsButton?.nativeElement,
            collision: 'fit'
          };
    }


  }

public broadcastTokenToIframes(newToken: string): void {
  if (!this.iframes || this.iframes.length === 0) {

    // volver a intentar luego de un pequeño delay
    setTimeout(() => this.broadcastTokenToIframes(newToken), 500);
    return;
  }

  // this.iframes.forEach((iframeRef) => {
  //   const iframe = iframeRef.nativeElement as HTMLIFrameElement;
  //    const targetOrigin = new URL(iframe.src).origin;
     
  //   iframe.contentWindow?.postMessage(
  //     { type: 'TOKEN_UPDATE', token: newToken },
  //     '*'
  //   );
  // });
this.iframes.forEach((iframeRef) => {

  const iframe = iframeRef.nativeElement as HTMLIFrameElement;

  if (!iframe?.src || !iframe.contentWindow) {
    return;
  }

  try {

    const targetOrigin = new URL(iframe.src).origin;

    iframe.contentWindow.postMessage(
      {
        type: 'TOKEN_UPDATE',
        token: newToken
      },
      targetOrigin
    );

  } catch (error) {

    console.error(
      'No fue posible obtener el origin del iframe:',
      iframe.src,
      error
    );
  }
});
 
}

}
